// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ie_a","col":"styles_col__1bBtn"};